import { isGUID } from '@client/shared/utils/utils/utils';
import httpRequest from './httpRequest';
import {
  getBaseRequestConfig,
  LOCAL_BASE_PATH,
  LOCAL_HLF_BASE_PATH,
} from './baseRequestConfig';

export function postDonation(donation, id = '') {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/donation/${id}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: donation,
  });

  return httpRequest(requestConfig);
}

export function postDonationPayment(
  paymentData,
  fundraiserId = '',
  donationId = ''
) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/donation/${fundraiserId}/${donationId}/payment`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: paymentData,
  });

  return httpRequest(requestConfig);
}

export function postDonationError(
  queryParams,
  fundraiserId = '',
  donationId = ''
) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/donation/${fundraiserId}/${donationId}/error`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: queryParams,
  });

  return httpRequest(requestConfig);
}

export function fetchDonation(donationId = '') {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/donation/${donationId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function fetchFundraiserDonations(slug) {
  const baseRequestConfig = getBaseRequestConfig();
  const urlSegment = isGUID(slug) ? `${slug}` : `slug/${slug}`;

  const url = `${LOCAL_BASE_PATH}/donation/fundraiser/${urlSegment}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function paymentRequest(data) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_HLF_BASE_PATH}/PaymentInit`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: data,
  });

  return httpRequest(requestConfig);
}
